'use client'
import React, { FunctionComponent, useCallback, useState } from 'react'
import cn from 'classnames'
import { useCaptcha } from '@/hooks/Captcha'

import { AcceptCheckbox } from '@/domains/Site/components/AcceptCheckbox'
import { Button } from '@/components/Button'

import styles from './HelpExpertForm.module.scss'
import { Input } from '@/components/Input'
import { HelpExpertFormStore } from './HelpExpertForm.store'
import { observer } from 'mobx-react-lite'

type HelpExpertFormProps = {
  className?: string
}
export const HelpExpertForm: FunctionComponent<HelpExpertFormProps> = observer(
  ({ className }) => {
    const { getToken } = useCaptcha()
    const [isSending, setIsSending] = useState(false)

    const [store] = useState(() => new HelpExpertFormStore())

    const onSubmit = useCallback(
      async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        setIsSending(true)
        try {
          const captchaToken = await getToken()
          await store.loaderSend.request(captchaToken)
        } finally {
          setIsSending(false)
        }
      },
      [getToken, store.loaderSend]
    )

    return (
      <form className={cn(styles.container, className)} onSubmit={onSubmit}>
        <div className={styles.content}>
          <div className={styles.title}>
            Нужна помощь патентного юриста-эксперта?
          </div>
          <div className={styles.description}>
            Оставьте номер телефона, мы перезвоним и проконсультируем по всем
            интересующим вас вопросам
          </div>
          <div className={styles.form}>
            <Input
              mask="+{7} (000) 000-00-00"
              placeholder="+7 (999) 999-99-99"
              className={styles.input}
              error={store.validator.errors.phone}
              name="phone"
              value={store.data.phone}
              onChange={store.setPhone}
            />
            <Button
              type="submit"
              className={styles.button}
              isLoading={isSending}
            >
              Отправить
            </Button>
          </div>
          <AcceptCheckbox
            className={styles.agree}
            error={store.validator.errors.accept}
            value={store.data.accept}
            onChange={store.setAccept}
            name={'agree'}
          />
        </div>
      </form>
    )
  }
)
